import { isKnownCalendarEventErrorCode } from '@griply/utils';
import { getErrorReporter } from 'shared/services/error-tracking';

// A known code is a per-user calendar state the UI already explains; only the rest is an incident.
export const reportUnknownCalendarEventError = (
  error: unknown,
  source: string,
): void => {
  if (isKnownCalendarEventErrorCode(error)) {
    return;
  }
  getErrorReporter().captureException(error, { tags: { source } });
};
